import {
  ClasseDefTypes,
  initialClasseState
} from '../../types/classe/classe.def';
import { initErrorFields } from '../../helpers/forms/error/errorFieldHelper';
import {
  CREATE_CLASSE,
  SetClasseFormAction
} from '../actions/createLyceeClasse.actions';
import { MainFormState } from '../../types/forms/form.def';

const initialState = {
  errors: initErrorFields({ classeName: null, filliere: null, niveau: null }),
  values: initialClasseState,
  isValid: false
};

export type CreateClasseState = MainFormState<ClasseDefTypes>;

const createClasse = (
  state: CreateClasseState = initialState,
  action: SetClasseFormAction
) => {
  switch (action.type) {
    case CREATE_CLASSE:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default createClasse;
